module.exports = __webpack_public_path__ + "img/age-null-icon.d230e072.svg";